import { getCultureCode, getCurrentEnterpriseId, getCurrentProfileIdOrNull } from '@mews-commander/core';
import {
    getCurrencyCultureInfo,
    getCurrencyLocalizationInfo,
    getCurrentDateTimeLocalizationInfo,
    getDayShortNames,
    getMonthNames,
    getMonthShortNames,
    getNumberCultureInfo,
} from '@mews-commander/core/legacy-globalization';
import { getApiBaseUrl, getGeneralApiBaseUrl } from '@mews-commander/data-access';
import { AppLocalizationComponentProps, containerConfiguration } from '@mews-commander/legacy-app-instance';
import {
    localizeEnum__DO_NOT_USE,
    localizeEnumify__DO_NOT_USE,
    localizeText__DO_NOT_USE,
} from '@mews-commander/legacy-app-instance/localization';
import { getProfileScopeId } from '@mews-commander/legacy-entities/src/ducks/scopes';
import { getCurrentEnterpriseIanaTimeZoneIdentifier } from '@mews-commander/legacy-entities/src/selectors/session/enterprise';
import { Application } from '@mews/enums';
import { container } from '@mews/framework';
import { getTextLocalizationInfo } from '../core/globalization/selectors';
import { getServerNowUtc, getVersion, getWebsocketUrl } from '../modules/app/reducers/configuration';

export default function createContainer({ store, contextWindow }: $TSFixMe) {
    const bind = createBinder(store);
    const baseApiConfiguration = {
        webSocketUrl: getWebsocketUrl,
        versionHash: getVersion,
        getCurrentProfileId: getCurrentProfileIdOrNull,
        getScopeIdByProfileId: bind(getProfileScopeId),
        getCurrentEnterpriseId,
    };

    const data = {
        globalization: {},
        api: {
            ...baseApiConfiguration,
            baseUrl: getApiBaseUrl,
        },
        generalApi: {
            ...baseApiConfiguration,
            baseUrl: getGeneralApiBaseUrl,
            application: Application.Commander,
        },
        appLocalization: {
            getCurrentEnterpriseIanaTimeZoneIdentifier: () =>
                getCurrentEnterpriseIanaTimeZoneIdentifier(store.getState()),
            getCurrencyCultureInfo: () => getCurrencyCultureInfo(store.getState(), { cultureCode: getCultureCode() }),
            getCurrencyLocalizationInfo: (currencyCode) =>
                getCurrencyLocalizationInfo(store.getState(), { currencyCode, cultureCode: getCultureCode() }),
            getCurrentDateTimeLocalizationInfo: () => getCurrentDateTimeLocalizationInfo(store.getState()),
            getDayShortNames,
            getMonthNames,
            getMonthShortNames,
            getNumberCultureInfo: () => getNumberCultureInfo(store.getState(), { cultureCode: getCultureCode() }),
            getTextLocalizationInfo: () => getTextLocalizationInfo(store.getState()),
            localizeEnum: localizeEnum__DO_NOT_USE,
            localizeEnumify: localizeEnumify__DO_NOT_USE,
            localizeText: (text, substitutes) => localizeText__DO_NOT_USE({ textKey: text, substitutes }),
        } satisfies AppLocalizationComponentProps,
        appClock: {
            getServerNowUtc,
            context: contextWindow,
        },
        appDate: {
            getCurrentEnterpriseIanaTimeZoneIdentifier: bind(getCurrentEnterpriseIanaTimeZoneIdentifier),
        },
    };
    return container(containerConfiguration(data));
}

const createBinder =
    ({ getState }: $TSFixMe) =>
    (selector: $TSFixMe) =>
    (props: $TSFixMe) =>
        selector(getState(), props);
